const navElements = [
  'Home',
  'Spread',
  'Trackers',
  'Interest',
  'Mood',
  'Collections',
  'Profile',
];

export default navElements;
